import { render, staticRenderFns } from "./DeleteRequestForm.vue?vue&type=template&id=d4390950&"
import script from "./DeleteRequestForm.vue?vue&type=script&lang=js&"
export * from "./DeleteRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports